const menu = {
  key: "userManual",
  route: "/user-manual",
  label: "sidebar.userManual",
  icon: "faBookOpen",
  group: "documentation",
  order: 10,
};

export default menu;
